var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 44
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11324 -1381)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 44,
    fill: "#f7fafa",
    "data-name": "Rechteck 15070",
    rx: 3,
    transform: "translate(-11324 1381)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a1f71",
    d: "m-11291.878 1395.016-7.254 17.3h-4.732l-3.57-13.81a1.9 1.9 0 0 0-1.063-1.52 18.7 18.7 0 0 0-4.416-1.472l.106-.5h7.618a2.09 2.09 0 0 1 2.065 1.763l1.886 10.014 4.657-11.777Zm18.541 11.655c.02-4.567-6.313-4.82-6.271-6.86.014-.62.605-1.281 1.9-1.449a8.45 8.45 0 0 1 4.415.775l.784-3.671a12.1 12.1 0 0 0-4.188-.765c-4.426 0-7.539 2.35-7.564 5.72-.028 2.491 2.224 3.88 3.918 4.71 1.746.848 2.331 1.392 2.323 2.15-.012 1.161-1.393 1.675-2.677 1.694a9.36 9.36 0 0 1-4.6-1.093l-.813 3.793a13.6 13.6 0 0 0 4.977.918c4.7 0 7.782-2.323 7.8-5.921m11.687 5.65h4.139l-3.617-17.3h-3.818a2.04 2.04 0 0 0-1.907 1.269l-6.718 16.036h4.7l.933-2.584h5.743Zm-5-6.131 2.357-6.5 1.356 6.5Zm-18.834-11.174-3.7 17.3h-4.477l3.7-17.3Z",
    "data-name": "Pfad 1555"
  }))));
};
export default SvgVisa;